import { gql } from '../../../apollo/__generated__';

export const DELETE_VOUCHER = gql(`
  mutation DeleteVoucher($voucherId: ID!) {
    deleteVoucher(voucherId: $voucherId) {
      id
    }
  }
`);
